import React, { Fragment } from "react"
import { Input, Checkbox, Tooltip, Spin, Tag } from "antd"
import {
  includes,
  truncate,
  map,
  slice,
  uniqBy,
  orderBy,
  flatMap,
} from "lodash"
import { Link } from "react-router-dom"
import InfiniteScroll from "react-infinite-scroller"
import TruncateTextTooltip from "components/TruncateTextTooltip"
import roundPencilSvg from "../../images/round-pencil.svg"
import roundDeleteSvg from "../../images/round-delete.svg"
import { LoadingOutlined } from "@ant-design/icons"
import { isModuleBySlug, LOCAL_VISMA_PEOPLE_SYNC_ENABLED } from "../../utils/storage"
import { SEGMENTS } from "../../utils/constants"
import { buttonAction_btns } from "../Snowplow/config2"

const CheckboxGroup = Checkbox.Group

const renderTitleTooltipTeam = (props, record) => {
  const { isLoadingCollaboratorTeam, collaboratorTeam } = props
  const antIcon = <LoadingOutlined style={{ fontSize: 24, color: "#FFF" }} />
  if (isLoadingCollaboratorTeam)
    return <Spin size="large" indicator={antIcon} />

  return (
    <div className="collaborators-team-tooltip">
      {map(slice(collaboratorTeam, 0, 5), (item, index) => {
        return (
          <span key={index}>
            {index + 1}. {item.full_name}
          </span>
        )
      })}
      {collaboratorTeam.length > 5 && (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            openModalOf("modalTeam", true, record)
            getTeamPotential(record.id_employee)
          }}>
          Ver más
        </span>
      )}
    </div>
  )
}

const renderColumnTeam = (text, record, props) => {
  const {
    collaboratorTeam,
    getTeam,
    getTeamPotential,
    openModalOf,
    isLoadingCollaboratorTeam,
  } = props
  if (text && text.count_team) {
    return (
      <Tooltip
        placement="top"
        title={renderTitleTooltipTeam(
          { collaboratorTeam, isLoadingCollaboratorTeam },
          record
        )}>
        <span
          onMouseEnter={() => getTeam(record.id_employee)}
          onClick={() => {
            openModalOf("modalTeam", true, record)
            getTeamPotential(record.id_employee)
          }}
          style={{
            textDecoration: text.count_team ? "underline" : "none",
            cursor: text.count_team ? "pointer" : "default",
          }}>
          {text.count_team}
        </span>
      </Tooltip>
    )
  }

  return (
    LOCAL_VISMA_PEOPLE_SYNC_ENABLED() ? '-' : 
    <span
      onClick={() => {
        getTeam(record.id_employee)
        getTeamPotential(record.id_employee)
        openModalOf("modalTeam", true, record)
        buttonAction_btns("Agregar colaborador")
      }}
      className="collaborators-team-add">
      + Agregar
    </span>
  )
}

const renderColumnName = (text, record, props) => {
  const { openModalOf, toggleModal } = props
  return (
    <div className="collaborators-name">
      <span>
        {record.id_ambassador ? (
          <Link
            className="linkHover"
            to={`ambassador/${record.id_ambassador}?rd=organization`}>
            <TruncateTextTooltip title={text} />
          </Link>
        ) : (
          <TruncateTextTooltip title={text} />
        )}
      </span>
      <div className="collaborators-name-actions">
        <Link to={`/organization/collaborators/edit/${record.id_employee}`}>
          <img src={roundPencilSvg} alt="round-pencil" />
        </Link>
        {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
          <img
            alt="round-delete-svg"
            src={roundDeleteSvg}
            onClick={() => {
              openModalOf("modalDeleteCollaborators", true, [record.id_employee])
              toggleModal("modalDeleteCollaborators", true)
            }}
          />
        )}
      </div>
    </div>
  )
}

const renderTeam = (props) => {
  const {
    collaboratorTeam,
    getTeam,
    getTeamPotential,
    openModalOf,
    isLoadingCollaboratorTeam,
  } = props
  return {
    title: "Equipo",
    key: "team",
    dataIndex: "team",
    // width: "10%",
    sorter: true,
    render: (text, record) =>
      renderColumnTeam(text, record, {
        collaboratorTeam,
        getTeam,
        getTeamPotential,
        openModalOf,
        isLoadingCollaboratorTeam,
      }),
  }
}

const leaderDropdown = (props, filterFor, leader) => {
  return (
    <div className="collaborators-dropdown-filter">
      <Input
        value={leader.inputSearchLeader}
        onChange={(e) => filterFor("leaders", e.target.value)}
        className="collaborators-dropdown-input"
        placeholder="Buscar..."
      />
      <CheckboxGroup
        value={leader.leadersSelected}
        className="collaborators-dropdown-checkboxs"
        onChange={(e) => filterFor("leadersSelected", e)}>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => leader.filterLoadMoreLeader()}
          threshold={60}
          hasMore={leader.hasMoreLeaders}
          loader={
            <div className="loader" key={0}>
              Loading ...
            </div>
          }
          useWindow={false}>
          {map(
            orderBy(
              uniqBy(leader.leaders, "employee_parent_name"),
              [(l) => l.employee_parent_name ? l.employee_parent_name.toLowerCase() : ''],
              ['asc']
            ),
            (item, index) => {
              if (!item.employee_parent_name) return

              return (
                <Checkbox key={index} value={item.id_employee_parent}>
                  {truncate(item.employee_parent_name, { length: 30 })}
                </Checkbox>
              )
            }
          )}
        </InfiniteScroll>
      </CheckboxGroup>
      <div className="collaborators-dropdown-footer">
        <span
          onClick={() => {
            leader.filterForLeaderOk()
            leader.closeDropdown()
          }}>
          Ok
        </span>
        <span
          onClick={() => {
            leader.filterForLeaderRestart()
            leader.closeDropdown()
          }}>
          Reiniciar
        </span>
      </div>
    </div>

  )

}

const renderLeader = (props) => {
  const { openModalOf, filterFor, leader } = props
  return {
    title: "Líder",
    key: "employee_parent_name",
    dataIndex: "employee_parent_name",
    // width: "10%",
    sorter: true,

    filterDropdown: (...props) => leaderDropdown(...props, filterFor, leader),
    filterDropdownVisible: leader.dropdownOpen,
    onFilterDropdownVisibleChange: leader.onVisibleChange,
    filtered: leader.leadersSelected && leader.leadersSelected.length > 0,
    filteredValue: leader.leadersSelected || [],
    defaultFilteredValue: leader.leadersSelected || [],
    render: (text, record) => {
      if (text) {
        return <TruncateTextTooltip title={text} />
      }
      return (
        LOCAL_VISMA_PEOPLE_SYNC_ENABLED() ? '-' : 
        <span
          onClick={() => openModalOf("modalSelectLeader", true, record)}
          className="collaborators-dropdown-link">
          Seleccionar
        </span>
      )
    },
  }
}

const divisionDropdown = (props, filterFor, division) => {

  return (
    <div className="collaborators-dropdown-filter">
      <Input
        value={division.inputSearchDivision}
        onChange={(e) => filterFor("divisions", e.target.value)}
        className="collaborators-dropdown-input"
        placeholder="Buscar..."
      />
      <CheckboxGroup
        value={division.divisionsSelected}
        className="collaborators-dropdown-checkboxs"
        onChange={(e) => filterFor("divisionsSelected", e)}>
        {map(orderBy(uniqBy(division.divisions, "division_name"), [(d) => d.division_name ? d.division_name.toLowerCase() : ''], ['asc']), (div) => {
          if (!div.division_name) return
          return (
            <Checkbox key={div.id_division} value={div.id_division}>
              {truncate(div.division_name, { length: 30 })}
            </Checkbox>
          )
        })}
      </CheckboxGroup>
      <div className="collaborators-dropdown-footer">
        <span
          onClick={() => {
            division.filterForDivisionOk()
            division.closeDropdown()
          }}>
          Ok
        </span>
        <span
          onClick={() => {
            division.filterForDivisionRestart()
            division.closeDropdown()
          }}>
          Reiniciar
        </span>
      </div>
    </div>
  )
}

const renderDivision = (props) => {
  const { filterFor, division } = props
  return {
    title: "División",
    key: "division_name",
    dataIndex: "division_name",
    // width: "15%",
    sorter: true,

    filterDropdown: (...props) =>
      divisionDropdown(...props, filterFor, division),
    filterDropdownVisible: division.dropdownOpen,
    onFilterDropdownVisibleChange: division.onVisibleChange,
    filtered: division.divisionsSelected && division.divisionsSelected.length > 0,
    filteredValue: division.divisionsSelected || [],
    defaultFilteredValue: division.divisionsSelected || [],
    render: (text) => <TruncateTextTooltip title={text} />,
  }
}

const segmentDropdown = (props, filterFor, segment) => {
  return (
    <div className="collaborators-dropdown-filter">
      <Input
        value={segment.inputSearchSegment}
        onChange={(e) => filterFor("segments", e.target.value)}
        className="collaborators-dropdown-input"
        placeholder="Buscar..."
      />
      <CheckboxGroup
        value={segment.segmentsSelected}
        className="collaborators-dropdown-checkboxs"
        onChange={(e) => filterFor("segmentsSelected", e)}>
        {map(orderBy(segment.segments, [(s) => s.name_segment ? s.name_segment.toLowerCase() : ''], ['asc']), (seg) => {
          if (!seg.name_segment) return
          return (
            <Checkbox key={seg.id_segment} value={seg.id_segment}>
              {truncate(seg.name_segment, { length: 30 })}
            </Checkbox>
          )
        })}
      </CheckboxGroup>
      <div className="collaborators-dropdown-footer">
        <span
          onClick={() => {
            segment.filterForSegmentsOk()
            segment.closeDropdown()
          }}>
          Ok
        </span>
        <span
          onClick={() => {
            segment.filterForSegmentsRestart()
            segment.closeDropdown()
          }}>
          Reiniciar
        </span>
      </div>
    </div>
  )
}

const renderSegments = (props) => {

  const { filterFor, segment } = props
  const { toggleSegmentsModal } = props
  return {
    title: "Segmentos",
    key: "segments",
    dataIndex: "segments",
    // width: "200px",
    filterDropdown: (...props) => segmentDropdown(...props, filterFor, segment),
    filterDropdownVisible: segment.dropdownOpen,
    onFilterDropdownVisibleChange: segment.onVisibleChange,
    filtered: segment.segmentsSelected && segment.segmentsSelected.length > 0,
    filteredValue: segment.segmentsSelected || [],
    defaultFilteredValue: segment.segmentsSelected || [],
    sorter: true,
    render: (text, row) => {
      let tags = []
      if (row.segments.length > 0) {
        tags.push(
          <Tag
            style={{
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {row.segments[0].name_segment}
          </Tag>
        )
        if (row.segments.length > 1) {
          tags.push(
            <Tooltip
              title={() => {
                let segmentsName = []
                for (let i = 0; i < row.segments.length; i++) {
                  if (i === 10) {
                    segmentsName.push(
                      <p
                        style={{ margin: 0, cursor: "pointer" }}
                        onClick={() => {
                          toggleSegmentsModal(row.segments, row.full_name)
                        }}>
                        Ver más
                      </p>
                    )
                    break
                  }
                  segmentsName.push(
                    <p
                    key={`segment-${i}`} 
                      style={{
                        margin: 0,
                        maxWidth: "150px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}>
                      {i + 1}. {row.segments[i].name_segment}
                    </p>
                  )
                }
                return <>{segmentsName}</>
              }}>
              <Tag
                key={row.id_segment} 
                style={{
                  pointer: "cursor",
                  maxWidth: "50px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                {row.segments.length - 1}+
              </Tag>
            </Tooltip>
          )
        }
      } else {
        tags.push(<span>-</span>)
      }

      return tags
    },
  }
}

const renderPosition = () => {
  return {
    title: "Puesto",
    dataIndex: "position_name",
    // width: "10%",
    key: "position_name",
    sorter: true,
    
    render: (text, record) => {
      if (record.general_manager) {
        return <span style={{ color: "#2bba9a" }}>Gerente General</span>
      }
      return <TruncateTextTooltip title={text} />
    },
  }
}

const renderEmail = () => {
  return {
    title: "Correo",
    dataIndex: "email",
    key: "email",
    // width: "220px",
    sorter: true,
    
  }
}

const titleTooltipAmbassador = (rest) => {
  return (
    <div
      className="collaborators-team-tooltip"
      style={{ maxHeight: 100, overflow: "auto" }}>
      {map(rest, (item, index) => {
        return <span key={index}>{item}</span>
      })}
    </div>
  )
}

const renderColumnAmbassador = (text) => {
  if (!text || !text.length) return "-"

  const separate = flatMap(text, (item) => item.division_ambassador_name)
    .slice(0, 1)
    .join(", ")
  const rest = flatMap(text, (item) => item.division_ambassador_name).slice(
    1,
    text.length
  )

  return (
    <Fragment>
      <span
        className="string_dots"
        style={{
          display: "inline-block",
          maxWidth: text.length > 1 ? "80%" : "100%",
        }}>
        {separate}
      </span>
      {text.length > 1 ? (
        <Fragment>
          <span style={{ display: "inline-block", verticalAlign: "top" }}>
            ,{" "}
          </span>{" "}
          <Tooltip placement="top" title={titleTooltipAmbassador(rest)}>
            <span
              style={{ display: "inline-block", verticalAlign: "top" }}
              className="hover-underline">
              {" "}
              +{text.length - 1}
            </span>
          </Tooltip>
        </Fragment>
      ) : null}
    </Fragment>
  )
}

const renderAmbassador = () => {
  return {
    title: "Embajador",
    dataIndex: "division_ambassadors",
    // width: "10%",
    key: "division_ambassadors",
    render: (text) => renderColumnAmbassador(text),
  }
}

const renderBirthday = () => {
  return {
    title: "Fecha de nacimiento",
    dataIndex: "date_birth",
    // width: "10%",
    sorter: true,
    
    key: "date_birth",
  }
}

const renderDNI = () => {
  return {
    title: "DNI",
    dataIndex: "document",
    // width: "10%",
    sorter: true,
    
    key: "document",
  }
}

const renderUpCategory = () => {
  return {
    title: "Categoría jerárquica",
    dataIndex: "plevel_name",
    key: "plevel_name",
    // width: "8%",
    sorter: true,
    
    render: (text) => {
      return <div className="string_dots">{text}</div>
    },
  }
}

const renderGeoLocation = () => {
  return {
    title: "Ubicación geográfica",
    dataIndex: "location",
    key: "location",
    // width: "8%",
    sorter: true,
    
    render: (text) => <div className="string_dots">{text}</div>,
  }
}

const renderGender = () => {
  return {
    title: "Género",
    dataIndex: "gender_name",
    // width: "5%",
    key: "gender_name",
    sorter: true,
    
  }
}

export const columns = ({
  columnsSelected,
  filterFor,
  openModalOf,
  leader,
  division,
  segment,
  getTeam,
  isLoadingCollaboratorTeam,
  collaboratorTeam,
  getTeamPotential,
  toggleModal,
  addItemsUpdateToDropdown,
  hasSegments,
  toggleSegmentsModal,
  sortField,
  sortOrder,
}) => {
  const colDefaultSortOrder = (field) => {
    if (sortField !== field || !sortOrder) return undefined
    return sortOrder === 'asc' ? 'ascend' : 'descend'
  }

  const dataColumns = [
    {
      title: "Nombre",
      key: "first_name",
      dataIndex: "first_name",
      // width: "205px",
      sorter: true,
      defaultSortOrder: colDefaultSortOrder('first_name'),
      render: (text, record) =>
        renderColumnName(text, record, { openModalOf, toggleModal }),
    },
    {
      title: "Apellidos",
      // width: "205px",
      key: "last_name",
      sorter: true,
      defaultSortOrder: colDefaultSortOrder('last_name'),
      render: (record) => (
        <TruncateTextTooltip
          title={`${record.last_name} ${record.second_last_name}`}
        />
      ),
    },
  ]
  if (includes(columnsSelected, "email")) {
    dataColumns.push({ ...renderEmail(), defaultSortOrder: colDefaultSortOrder('email') })
  }
  dataColumns.push(renderPosition())
  if (includes(columnsSelected, "division")) {
    dataColumns.push(
      renderDivision({ addItemsUpdateToDropdown, filterFor, division })
    )
  }
  if (
    includes(columnsSelected, "segment") &&
    hasSegments &&
    isModuleBySlug(SEGMENTS)
  ) {
    dataColumns.push(
      renderSegments({
        addItemsUpdateToDropdown,
        filterFor,
        segment,
        toggleSegmentsModal,
      })
    )
  }
  if (includes(columnsSelected, "leader")) {
    dataColumns.push(
      renderLeader({ openModalOf, addItemsUpdateToDropdown, filterFor, leader })
    )
  }
  if (includes(columnsSelected, "team")) {
    dataColumns.push(
      renderTeam({
        collaboratorTeam,
        getTeam,
        getTeamPotential,
        openModalOf,
        isLoadingCollaboratorTeam,
      })
    )
  }
  if (includes(columnsSelected, "ambassador")) {
    dataColumns.push(renderAmbassador())
  }
  if (includes(columnsSelected, "birthdate")) {
    dataColumns.push(renderBirthday())
  }
  if (includes(columnsSelected, "dni")) {
    dataColumns.push(renderDNI())
  }
  if (includes(columnsSelected, "up_category")) {
    dataColumns.push(renderUpCategory())
  }
  if (includes(columnsSelected, "geo_location")) {
    dataColumns.push(renderGeoLocation())
  }
  if (includes(columnsSelected, "gender")) {
    dataColumns.push(renderGender())
  }
  return dataColumns
}
